import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Module } from '../../../models/user/user.model';
import { Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../store/states/app.state';
import { StoreName } from '../../../store/definitions/store.constants';
import { UserState } from '../../../store/states/user.state';
import { UserType } from '../../../permissions/definitions/permissions.enums';

@Injectable({
  providedIn: 'root'
})
export class HasPermissionsService {

  private modules: Module[];
  private userType: string;

  constructor(
    private readonly _store: Store<AppState>
  ) {
    this.subscribeUserStore();
  }

  checkPermission(permission: string): boolean {
    return Boolean(
      this.userType === UserType.admin ||
      (this.modules || []).map((module: Module) => module.slug).some((slug: string) => slug === permission)
    );
  }

  // Hierarchical (prefix) check: permissions are a tree (e.g. `financial-hub` ->
  // `financial-hub/companies` -> `financial-hub/companies/kam-creator`). Access to a module is
  // granted when the user holds the module slug itself OR any descendant of it. Use this for
  // routing/section access where any role under the module should pass; use checkPermission for
  // an exact leaf-role check.
  hasModuleAccess(modulePrefix: string): boolean {
    return Boolean(
      this.userType === UserType.admin ||
      (this.modules || []).some(
        (module: Module) => module.slug === modulePrefix || module.slug.startsWith(`${modulePrefix}/`)
      )
    );
  }

  isAdmin(): boolean {
    return this.userType === UserType.admin;
  }

  private subscribeUserStore() {
    this._store.pipe(select(StoreName.user)).subscribe((user: UserState) => {
      this.userType = user.user_type;
      this.modules = user.modules;
    });
  }
}
